import { SubtitleSegment } from '../../subtitle-segment';

export default class ContentControlSubtitlesContainer {
  public segmentsMap: { [lang: string]: Array<SubtitleSegment> };
  constructor(segmentsMap?: { [lang: string]: Array<SubtitleSegment> }) {
    this.segmentsMap = { ...segmentsMap } || {};
  }
  public clone() {
    const sm: { [lang: string]: Array<SubtitleSegment> } = {};
    Object.keys(this.segmentsMap).forEach((key) => {
      sm[key] = this.segmentsMap[key].map((x) => {
        return { ...x } as SubtitleSegment;
      });
    });
    return new ContentControlSubtitlesContainer(sm);
  }
  public get Lanaguages() {
    return Object.keys(this.segmentsMap);
  }
  public addSubtitleSegments(lang: string, subs: Array<SubtitleSegment>) {
    subs.sort((a, b) => a.StartTimeMS - b.StartTimeMS);
    this.segmentsMap[lang] = [...subs];
  }
  public mergeSubtitleSegments(lang: string, subs: Array<SubtitleSegment>) {
    subs.sort((a, b) => a.StartTimeMS - b.StartTimeMS);
    const existingSubs = this.segmentsMap[lang] || [];
    for (const sub of subs) {
      const existingSub = existingSubs.find(
        (x) =>
          x.StartTimeMS === sub.StartTimeMS && x.EndTimeMS === sub.EndTimeMS,
      );
      if (existingSub) {
        sub.Text = existingSub.Text;
      }
    }
    this.segmentsMap[lang] = [...subs];
  }

  public subtitleSegments(lang: string) {
    return this.segmentsMap[lang];
  }
}
